/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbAnneeReussieDto } from './FcbAnneeReussieDto';
import {
    FcbAnneeReussieDtoFromJSON,
    FcbAnneeReussieDtoFromJSONTyped,
    FcbAnneeReussieDtoToJSON,
} from './FcbAnneeReussieDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbAnneeReussieDtoPaginatedResults
 */
export interface FcbAnneeReussieDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbAnneeReussieDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbAnneeReussieDto>}
     * @memberof FcbAnneeReussieDtoPaginatedResults
     */
    results?: Array<FcbAnneeReussieDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbAnneeReussieDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbAnneeReussieDtoPaginatedResults interface.
 */
export function instanceOfFcbAnneeReussieDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbAnneeReussieDtoPaginatedResultsFromJSON(json: any): FcbAnneeReussieDtoPaginatedResults {
    return FcbAnneeReussieDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbAnneeReussieDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbAnneeReussieDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbAnneeReussieDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbAnneeReussieDtoPaginatedResultsToJSON(value?: FcbAnneeReussieDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbAnneeReussieDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

